// Slow editorial marquee band.
export default function Marquee() {
  const phrase = "ELECTION ON MARS";
  const items = Array.from({ length: 8 });

  return (
    <div
      data-testid="marquee-band"
      className="relative overflow-hidden border-y border-white/10 bg-rebellion py-5 md:py-6"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((_, i) => (
          <span key={i} className="flex items-center">
            <span className="px-6 font-display text-3xl uppercase tracking-tight text-white md:text-5xl">
              {phrase}
            </span>
            <span className="px-6 font-editorial text-2xl italic text-white/70 md:text-4xl">
              a political reckoning
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
